export const translate = key => window.__litium && window.__litium.translation[key] || key;